// You can write your custom Javascript here
if(document.getElementsByClassName('discover-btn').length > 0){
  document.getElementsByClassName('discover-btn')[0].addEventListener('mouseover', () => {
    let discoverMenu = document.getElementsByClassName('menu--discover')[0].getElementsByClassName('dropdown__menu')[0]
    discoverMenu.style.borderTop = "1px solid #c8c8c8"
    discoverMenu.style.maxHeight = "1000px"
    document.getElementsByTagName('body')[0].classList.add('no-scroll');
  })
  document.getElementsByClassName('discover-btn')[0].addEventListener('mouseout', () => {
    let discoverMenu = document.getElementsByClassName('menu--discover')[0].getElementsByClassName('dropdown__menu')[0]
    discoverMenu.style.removeProperty('border-top');
    discoverMenu.style.removeProperty('max-height');
    document.getElementsByTagName('body')[0].classList.remove('no-scroll');
  })
}

function hideMobileMenuBanner() {
  var banner = document.querySelector('.mobile-menu-banner');
  if (banner) banner.classList.add('hide');
}

function removeMobileMenuBanner() {
  var banner = document.querySelector('.mobile-menu-banner');
  if (banner) banner.classList.remove('hide');
}

// Hide promo banner when drilling into a primary item with a dropdown, or when using the mobile back row.
document.addEventListener('click', function (event) {
  if (event.target.closest('.menu__item--primary .dropdown-item') && !event.target.closest('.menu__item--primary .dropdown-item.active')) {
    hideMobileMenuBanner();
    return;
  }
  if (event.target.closest('.menu__item--primary .dropdown-item.active')) {
    removeMobileMenuBanner();
    return;
  }
});

// Fix AudioEye cart issue
(function () {
  var drawer = document.querySelector('.sidecart');
  if (!drawer) return;

  function clearInert() {
    if (document.body.classList.contains('ajax-cart-open') && drawer.hasAttribute('inert')) {
      drawer.removeAttribute('inert');
    }
  }

  clearInert();
  new MutationObserver(clearInert).observe(drawer, { attributes: true, attributeFilter: ['inert'] });
  new MutationObserver(clearInert).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();